import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-black text-white border-t-4 border-black"
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-10 grid grid-cols-1 md:grid-cols-3 gap-6">
        <div>
          <div className="font-anton text-3xl uppercase">
            Srehan<span className="text-[#FFD600]">.</span>
          </div>
          <div className="text-sm text-zinc-400 mt-2 font-outfit">
            srehandeshmukh.com
          </div>
        </div>
        <div className="flex md:justify-center items-start gap-6 text-sm font-outfit">
          <Link to="/" data-testid="footer-work" className="hover:text-[#FFD600]">Work</Link>
          <Link to="/about" data-testid="footer-about" className="hover:text-[#FFD600]">About</Link>
          <Link to="/contact" data-testid="footer-contact" className="hover:text-[#FFD600]">Contact</Link>
          <Link to="/admin/login" data-testid="footer-admin" className="hover:text-[#FFD600] opacity-60">Admin</Link>
        </div>
        <div className="md:text-right text-sm text-zinc-400 font-outfit">
          © {year} Srehan Deshmukh. Built brick by brick.
        </div>
      </div>
    </footer>
  );
}
